import styled from 'styled-components';

import { Color } from '../../../enums';
import { StyledComponent } from '../../../interfaces';
import { Image } from '../../image/image.component';

export const Container: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const ImagePlaceholder: StyledComponent<'div'> = styled.div`
  width: 100px;
  height: 100px;
  flex-shrink: 0;
  border: 1px solid ${Color.Gray200};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const ImageElement: StyledComponent<typeof Image> = styled(Image)`
  width: 100px;
  height: 100px;
  flex-shrink: 0;
  object-fit: cover;
  cursor: pointer;
`;

export const Details: StyledComponent<'div'> = styled.div`
  margin-left: 16px;
  width: 100%;
`;

export const IconButton: StyledComponent<'button'> = styled.button``;
